const EXTERNAL_LINKS = {
  TERMS_OF_USE: 'https://www.psyomics.com/termsofuse',
  PRIVACY_POLICY: 'https://www.psyomics.com/privacy-policy',

  INSTRUCTIONS_FOR_USE: 'https://www.psyomics.com/beseenIFU',
  FURTHER_INFORMATION: 'https://www.psyomics.com/beseenValidatedMeasures',
} as const;

const SUPPORT_EMAIL = 'support@psyomics.com';

export { EXTERNAL_LINKS, SUPPORT_EMAIL };
